import React, { ReactElement, useEffect, useState } from 'react';
import Panel from '../../../shared/components/card/Panel';
import { QualificationsRequestObject, Week } from '../../../shared/models/inventory.model';
import SmallCalendar from './SmallCalendar';
import { DoctorDetails, Qualifications, WorkingSlots } from './../../../shared/models/inventory.model';
import { SaveDoctorDetails } from './SaveDoctors';
import { Moment } from 'moment';
import { getMinutesFromDate, success } from '../../../utils/utility';
import { error } from './../../../utils/utility';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDoctorsList } from '../../../store/actions/inventoryAction';
import { Button } from 'antd';

const SlotsCalendar = ({ title, action, data, isInline, userId, isReadOnly, onRefresh }: any): ReactElement => {
  const { workingSlots: slots } = data ? data : {} as any;
  const dispatch = useDispatch();
  const [weeks, setWeeks] = useState(null as any);
  const doctorsDetailList = useSelector(({ inventory: { doctorsList } }: any): DoctorDetails[] => doctorsList);
  const [doctorDetails, setDoctorDetails] = useState(data);

  useEffect((): void => {
    if (doctorsDetailList && !data && userId) {
      setDoctorDetails(doctorsDetailList.filter((v: DoctorDetails): boolean => {
        return +v.id === +userId;
      })[0]);
    }
  }, [doctorsDetailList]);

  const onSaveSlots = async (week: Week[]): Promise<void> => {
    const doctorDetail: DoctorDetails = doctorDetails ? {
      ...doctorDetails,
      professionalDetail: doctorDetails.professionalDetail && doctorDetails.professionalDetail.departmentId ? {
        ...doctorDetails.professionalDetail,
        qualifications: doctorDetails.professionalDetail.qualifications ?
          getQualifications(doctorDetails.professionalDetail.qualifications) : null,
      } : null,
      workingSlots: getWorkingSlots(week),
      consultationDetail: doctorDetails.consultationDetail && doctorDetails.consultationDetail.consultationType ? {
        ...doctorDetails.consultationDetail,
      } : null,
    } : error('');
    if (!doctorDetails) {
      return;
    }
    const response: any = await SaveDoctorDetails(doctorDetail);
    if (response && response.isSuccess && !response.errorMessage) {
      success(`Working slots ${action === 'Save' ? 'saved' : 'updated'} successfully`);
      dispatch(fetchDoctorsList({}));
      if (isInline) {
        onRefresh();
      }
    } else if (response && response.isSuccess && response.errorMessage) {
      error(response.errorMessage);
    } else if (response && !response.isSuccess && response.errorMessage) {
      error(response.errorMessage);
    } else {
      error(`Working slots ${action === 'Save' ? 'save' : 'update'} failed`);
    }
  };

  const getQualifications = (qualification: Qualifications[]): QualificationsRequestObject[] => {
    const qualifications: QualificationsRequestObject[] | any = (qualification && qualification.length > 0) ?
      qualification.map((v: Qualifications): any => {
        return {
          qualificationName: v.qualificationName,
          additionalQualification: v.additionalQualification,
        };
      }) : null;
    return qualifications;
  };

  const getWorkingSlots = (weekSlots: Week[]): WorkingSlots[] => {
    const modifiedWorkingSlots: Week[] | any = (weekSlots && weekSlots.length) ? weekSlots.filter((day: Week): boolean =>
      (day.start !== undefined && day.slotsRanges && day.slotsRanges.length > 0)) : null;
    const workingSlots: WorkingSlots[] | any = (modifiedWorkingSlots && modifiedWorkingSlots.length > 0) ?
      modifiedWorkingSlots.map((workDay: Week): any => {
        const io = workDay.slotsRanges.map((vvv: Moment): any => {
          return {
            startTime: getMinutesFromDate(vvv[0]._d),
            endTime: getMinutesFromDate(vvv[1]._d),
          };
        });
        return {
          dayOfWeek: workDay.value,
          slots: io,
        };
      }) : null;
    return workingSlots;
  };

  return (
    <Panel bordered={isInline ? false : true} actions={
      [
        <Button disabled={isReadOnly} key={'action-key'} type="primary" onClick={(): Promise<void> => onSaveSlots(weeks)}>{action}</Button>,
      ]
    }
      title={title} className="slots-calendar">
      <SmallCalendar
        isReadOnly={isReadOnly}
        direction="column"
        slots={slots}
        action={action}
        onChangeSlots={(d: Week[]): void => setWeeks(d)} />
    </Panel>
  );
};

export default SlotsCalendar;
